import React, { useEffect, useState } from 'react';
import { Grid, useMediaQuery, Button } from '@mui/material';
import { BuyersCard } from 'component/BuyersCard/BuyersCard';
import { ExpandedCardOfferDetails } from './ExpandedCardOfferDetails';
import { Grade } from '@mui/icons-material';
import { useTheme } from '@emotion/react';
import ExpandCollapse from 'assets/svg/expand.svg';

export const ExpandedBuyersCard = ({
  data,
  popover,
  handleClosePopover,
  isSmall,
  marketShow,
  expandFeedback,
  setExpandFeedback,
  propertyValue,
  show,
  setShow,
  expand,
  setExpand,
  shrink,
  ownercardprop,
  isHidden,
  showowner,
  buyerId,
  activitywidth,
  rowData,
  buyercardcontact,
  buyerpropertylist,
  proid,
  setProid,
  userEmail,
  userType,
  proUniqueId,
  setProUniqueId,
  handleOptionChange,
  action,
  setOpendialog,
  opendialog,
  setOpenbuyermatch,
  openbuyermatch,
  setAction,
  buyercard,
  ownercardpopover,
  selectedPaAddressTwo,
  setSelectedPaAddressTwo,
  username,
  handleBlueline,
  pipelineCat,
  isPipelineCat,
  setIsPipelineCat,
  setPipelineCat,
  Propertylist,
  pipelineId,
  setPipelineId,
  isAppraisal,
  setIsAppraisal,
  fromSearch,
  catSelected,
  noteSelected,
  taskId,
  taskBinderId,
  address,
  onOpenAutomatedStage,
  onOpenIncompleteDetails,
  refreshPipeline,
  isPipelineManagement,
}) => {
  const theme = useTheme();
  const isSm = useMediaQuery((theme) => theme.breakpoints.only('sm'));
  const isXs = useMediaQuery((theme) => theme.breakpoints.only('xs'));
  const isMd = useMediaQuery((theme) => theme.breakpoints.only('md'));
  const matches1836 = useMediaQuery(theme.breakpoints.down(1836));
  const matches900 = useMediaQuery(theme.breakpoints.down(900));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches870 = useMediaQuery(theme.breakpoints.down(870));

  const toggleShow = () => {
    // {isSm && (setExpand(!expand))}
    if (opendialog || openbuyermatch) {
      setOpendialog(false);
      setOpenbuyermatch(false);
      setAction('');
    }
    setShow(!show);
  };

  const GroupExpand = ({ color = '#ECE8E8' }) => {
    return (
      <svg
        width="9"
        height="46"
        viewBox="0 0 9 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="8" height="46" rx="4" fill={color} />
        <path d="M1 23L7 19.5359L7 26.4641L1 23Z" fill={color} />
      </svg>
    );
  };

  const [hover, setHover] = useState(false);

  // const isSm = useMediaQuery((theme) => theme.breakpoints.down(430));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid
      sx={{
        display: 'flex',
        //border:"3px solid purple",
        // flexDirection: "column",
        // alignItems: "flex-end",
        // padding: "0px 0px 0px 5px",
        // gap: "20px",
        // width: "928px",
        // width:showowner?"100%": isHidden?"100%": expand && show? "100%": window.innerWidth<=900 ? "93%": expand && window.innerWidth < 950 ? "80%" :  "99%",
        width: matchessm ? '100%' : '98%',
        // paddingLeft:showowner ? "41%" : isHidden ? "21%": "0%",
        // height: "1588px",
        // background: isHidden ? "green" :"none",
        marginTop: '70px',
        marginLeft: matchessm
          ? '0px'
          : buyercard && matches900
          ? '-10px'
          : ownercardpopover && matches700
          ? '10px'
          : ownercardpopover && matches870
          ? '20px'
          : '',
        // paddingBottom: isHidden? "1000px" :'none',
      }}
    >
      {/* {ownercardprop && (
        <Grid item
                
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          cursor:"pointer",
          marginTop:"-140px",
        }}
      >
        <img src={ExpandCollapse} style={{marginTop:'-30px'}} onClick={toggleShow} /> */}
      {/* <ExpandCollapse onClick={toggleShow} /> */}

      {/* </Grid>
      )} */}
      {expand && !isSm && !shrink && (
        <Grid
          item
          // sx={{border:"3px solid red"}}
        >
          <Grid
            item
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              cursor: 'pointer',
              // marginTop:"-45px"
            }}
          >
            {/* <ExpandCollapse onClick={toggleShow} /> */}
            <img
              src={ExpandCollapse}
              style={{ marginTop: '-45px' }}
              onClick={toggleShow}
            />
          </Grid>
          <Grid sx={{ marginTop: '13px' }}>
            <Grid
              onClick={toggleShow}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              item
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                cursor: 'pointer',
                marginLeft: '21px',
                width: '10px',
                minHeight: '1000px',
                ':hover': {
                  backgroundColor: '#ebf2fe',
                },
                zIndex: '1000',
              }}
            >
              <GroupExpand color={hover ? '#8cb3f6' : '#ECE8E8'} />
            </Grid>
          </Grid>
        </Grid>
      )}
      <Grid
        sx={{ width: matchessm ? '100%' : '98%' }}
        //  border={"3px solid green"}
      >
        {buyerpropertylist?.length >= 1 && (
          <ExpandedCardOfferDetails
            data={data}
            address={address}
            marketShow={marketShow}
            expandFeedback={expandFeedback}
            setExpandFeedback={setExpandFeedback}
            propertyValue={propertyValue}
            show={show}
            isSmall={isSmall}
            expand={expand}
            setExpand={setExpand}
            ownercardprop={ownercardprop}
            buyerId={buyerId}
            activitywidth={activitywidth}
            rowData={rowData}
            buyercardcontact={buyercardcontact}
            buyerpropertylist={buyerpropertylist}
            proid={proid}
            setProid={setProid}
            userEmail={userEmail}
            userType={userType}
            proUniqueId={proUniqueId}
            setProUniqueId={setProUniqueId}
            action={action}
            handleOptionChange={handleOptionChange}
            handleClosePopover={handleClosePopover}
            popover={popover}
            ownercardpopover={ownercardpopover}
            selectedPaAddressTwo={selectedPaAddressTwo}
            setSelectedPaAddressTwo={setSelectedPaAddressTwo}
            openbuyermatch={openbuyermatch}
            opendialog={opendialog}
            username={username}
            handleBlueline={handleBlueline}
            isPipelineCat={isPipelineCat}
            pipelineCat={pipelineCat}
            setIsPipelineCat={setIsPipelineCat}
            setAction={setAction}
            setPipelineCat={setPipelineCat}
            Propertylist={Propertylist}
            pipelineId={pipelineId}
            setPipelineId={setPipelineId}
            isAppraisal={isAppraisal}
            setIsAppraisal={setIsAppraisal}
            fromSearch={fromSearch}
            catSelected={catSelected}
            noteSelected={noteSelected}
            taskId={taskId}
            taskBinderId={taskBinderId}
            onOpenAutomatedStage={onOpenAutomatedStage}
            onOpenIncompleteDetails={onOpenIncompleteDetails}
            refreshPipeline={refreshPipeline}
            isPipelineManagement={isPipelineManagement}
          />
        )}
      </Grid>
    </Grid>
  );
};
